// extracted by mini-css-extract-plugin
export var content = "_pj-1";
export var fullScreen = "_pj-0";